module.exports = __webpack_public_path__ + "static/img/3.39fd669.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/i80MobileImage/3.png
// module id = 63
// module chunks = 0